export const COOKIE_NOTIFICATION_TEXT = {
    description: 'Label text',
    defaultMessage: 'Cookie Notification Text',
    id: 'oe.event.cookieNotificationText',
};
export const CUSTOM_TIME_ZONE_TEXT = {
    description: 'Label text',
    defaultMessage: 'Custom Time Zone label',
    id: 'oe.website.customTimeZone',
};
export const DATA_IS_BEING_SAVED_TEXT = {
    id: 'oe.customFields.dataIsBeingSaved',
    description: 'Preloader message text',
    defaultMessage: 'Data is being saved, please wait{suffix}',
};
export const DAYS_TEXT = {
    id: 'oe.common.days',
    message: 'days',
    description: 'Label text',
};
export const FIELD_LABEL_TEXT = {
    description: 'Label text',
    defaultMessage: 'Field Label',
    id: 'oe.label.fieldLabel',
};
export const FOOTER_BAR_LOGO_IMAGE_TEXT = {
    id: 'oe.image.footerBarLogoImage',
    defaultMessage: 'Footer bar logo image',
    description: 'Label text'
};
export const IMAGE_BACKGROUND_TEXT = {
    id: 'oe.image.background',
    defaultMessage: 'Background image',
    description: 'Label text'
};
export const MAGIC_LINK_VALIDATION_PERIOD_TEXT = {
    defaultMessage: 'Magic Link validity period',
    id: 'oe.website.magicLinkValidationPeriod',
    description: 'Label text',
};
export const MAGIC_LINKS_VALID_FOR24_HOURS_TEXT = {
    id: 'oe.website.magicLinksValidFor24Hours',
    description: 'Label text',
    defaultMessage: 'Magic Links valid for 24 hours'
};
export const MAGIC_LINKS_VALID_UNTIL_EVENT_END_DATE_TEXT = {
    id: 'oe.website.magicLinksValidUntilEventEndDate',
    message: 'Magic Links valid until Event End Date +',
    description: 'Label text',
};
export const MENU_BAR_LOGO_IMAGE_TEXT = {
    id: 'oe.image.menuBarLogoImage',
    defaultMessage: 'Menu bar logo image',
    description: 'Label text'
};
export const MENU_BAR_LOGO_IMAGE_ALT_TEXT = {
    id: 'oe.image.menuBarLogoImageAltText',
    defaultMessage: 'Menu Bar Logo Image Alt Text',
    description: 'Label text'
};
export const LOGO_IMAGE_ALT_TEXT = {
    id: 'oe.image.logoImageAltText',
    defaultMessage: 'Logo Image Alt Text',
    description: 'Label text'
};
export const BACKGROUND_IMAGE_ALT_TEXT = {
    id: 'oe.image.backgroundImageAltText',
    defaultMessage: 'Background Image Alt Text',
    description: 'Label text'
};
export const ONE_STEP_REQUEST_ACCESS_CODE_TEXT = {
    message: 'One-Step Request Access Code and Sign In',
    id: 'oe.websiteTab.oneStepRequestAccessCode',
    description: 'Label text',
};
export const PRIVACY_POLICY_CHECKBOX_TEXT = {
    message: 'Privacy policy check box is {suffix}',
    id: 'oe.websiteTab.privacyPolicyCheckbox',
    description: 'Label text',
};
export const SIGN_IN_LANDING_WITH_TEXT = {
    id: 'oe.website.signInLandingWith',
    defaultMessage: 'Sign In Landing with',
    description: 'Label text',
};
export const TIME_ZONE_DISPLAY_THEME_TEXT = {
    description: 'Label text',
    defaultMessage: 'Time Zone Display',
    id: 'oe.website.timeZoneDisplay',
};
export const TOGGLE_COOKIE_NOTIFICATION_TEXT = {
    message: 'Enable / Disable Cookie Notification',
    id: 'oe.websiteTab.toggleCookieNotification',
    description: 'Label text',
};
export const WEBSITE_PASSPORT_THEME_TEXT = {
    id: 'oe.website.passportTheme',
    defaultMessage: 'Passport Theme',
    description: 'Label text',
};
export const PASSPORT_URL_TEXT = {
    id: 'oe.passportUrl',
    defaultMessage: 'Passport URL',
    description: 'Label text',
};
export const EVENT_TIMEZONE_FOR_MEETINGS_TEXT = {
    message: 'Display event time zone for all meetings is {suffix}',
    id: 'oe.websiteTab.eventTimeZoneForMeetingsEnabled',
    description: 'Label text',
};
export const EVENT_TIMEZONE_FOR_MEETINGS_INFO_TEXT = {
    defaultMessage: 'If display event time zone for all meetings is enabled, then wherever a meeting time is shown, the event time zone will be displayed. The format of the event time zone depends on the "Time Zone Display" setting.',
    id: 'oe.websiteTab.eventTimeZoneForMeetingsInfo',
    description: 'Label text',
};
export const CALENDAR_INVITES_INFO_TEXT = {
    defaultMessage: 'Download Calendar invites lets users download ICS files. When Subscribe to Calendar is selected, attendees can subscribe to receive Event and meetings calendar invites by email. Choosing Both provides attendees with flexibility to either Subscribe or download ICS files according to their preference.',
    id: 'oe.websiteTab.calendarInvitesInfo',
    description: 'Label text',
};
export const ATTENDEE_SSO_TEXT = {
    message: 'Attendee SSO is {suffix}',
    id: 'oe.websiteTab.attendeeSSOEnabled',
    description: 'Label text',
};
export const ATTENDEE_SSO_INFO_TEXT = {
    defaultMessage: 'Here you can enable attendee SSO configurations added to the account. They will apply for attendees whose domains match the domains associated with the SSO configuration.',
    id: 'oe.websiteTab.attendeeSSOInfo',
    description: 'Label text',
};
export const IDP_REQUIRED_TEXT = {
    defaultMessage: 'Please select at least one SSO configuration',
    id: 'oe.websiteTab.idpRequiredText',
    description: 'Label text',
};
export const CONTROLLED_AT_ACCOUNT_LEVEL_TEXT = {
    message: 'controlled at account level',
    id: 'oe.websiteTab.controlledAtAccountLevelText',
    description: 'Label text',
};